const breakpoint = 768;
// 関数定義 **********************************************************************
const fadeInUp = () => {
  let fadeInTargets = document.querySelectorAll('.js-fadeInUp');
  fadeInTargets.forEach((target) => {
    // FVセクションの場合は特別な処理
    const isFV = target.closest('.fv') !== null;
    // .fv__pattern-imgの場合はmd-lg以下（1000px以下）の時だけアニメーション適用
    const isPatternImg = target.classList.contains('fv__pattern-img');
    const mdLgBreakpoint = 1000;
    const isMdLgOrBelow = window.innerWidth <= mdLgBreakpoint;
    
    if (isFV) {
      // .fv__pattern-imgの場合は画面幅を判定
      if (isPatternImg && !isMdLgOrBelow) {
        // 1001px以上ではアニメーションを適用しない（CSSで既に表示状態になっている）
        return;
      }
      // FVセクションはページ読み込み時に即座にアニメーション（ScrollTriggerを使わない）
      // .fv__pattern-imgは他の要素とタイミングを合わせるため少し遅らせる
      const delay = isPatternImg ? 0.6 : 0.3;
      gsap.fromTo(target,
        {
          y: 50,
          autoAlpha: 0,
        },
        {
          y: 0,
          autoAlpha: 1,
          duration: 1.2,
          ease: "power2.out",
          delay: delay
        }
      );
    } else {
      // 通常の要素は従来通りScrollTriggerを使用
      gsap.fromTo(target,
        {
          y: 50,
          autoAlpha: 0,
        },
        {
          y: 0,
          autoAlpha: 1,
          duration: 1.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: target,
            start: 'top 85%',
            end: 'bottom 15%',
            toggleActions: 'play none none reverse',
            // Android対応の追加設定
            invalidateOnRefresh: true,
            refreshPriority: -1,
            // Android初期化問題の対策
            onRefresh: () => {
              // Androidで初期化時に表示されない問題を解決
              const isAndroid = /Android/i.test(navigator.userAgent);
              if (isAndroid) {
                setTimeout(() => {
                  const rect = target.getBoundingClientRect();
                  const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
                  if (isVisible && target.style.opacity === '0') {
                    gsap.to(target, {
                      y: 0,
                      autoAlpha: 1,
                      duration: 0.8,
                      ease: "power2.out"
                    });
                  }
                }, 100);
              }
            }
          }
        }
      );
    }
  });
}
const fadeIn = () => {
  let OnlyfadeInTargets = document.querySelectorAll('.js-fadeIn');
  OnlyfadeInTargets.forEach((target) => {
    gsap.fromTo(target,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.8,
        stagger: 0.1,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: target,
          start: 'top 80%',
        }
      }
    );
  });
}

// デバッグ機能（開発時のみ）
const debugAnimation = () => {
  if (window.location.search.includes('debug=1')) {
    console.log('GSAP Animation Debug Mode');
    
    const fadeInTargets = document.querySelectorAll('.js-fadeInUp');
    console.log(`Found ${fadeInTargets.length} fadeInUp targets`);
    
    fadeInTargets.forEach((target, index) => {
      console.log(`Target ${index}:`, {
        element: target,
        classList: target.classList.toString(),
        opacity: target.style.opacity,
        visibility: target.style.visibility,
        transform: target.style.transform
      });
    });
  }
};

// iPhone専用の最適化処理
const iPhoneOptimization = () => {
  const isIPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  
  if (isIPhone) {
    // iPhoneでのマップ表示最適化（1:1対応）
    const mapIframe = document.querySelector('.map__container iframe');
    if (mapIframe) {
      // マップの読み込み完了後にサイズを調整
      mapIframe.addEventListener('load', () => {
        setTimeout(() => {
          mapIframe.style.height = '100%';
          mapIframe.style.minHeight = '100%';
          // マップが枠いっぱいに表示されるよう調整
          mapIframe.style.transform = 'scale(1.2)';
          mapIframe.style.transformOrigin = 'center';
          // 余白を完全に埋める
          mapIframe.style.top = '-10%';
          mapIframe.style.left = '-10%';
          mapIframe.style.width = '120%';
          mapIframe.style.height = '120%';
        }, 100);
      });
    }
  }
};
const androidFallback = () => {
  // Androidデバイスかどうかを判定
  const isAndroid = /Android/i.test(navigator.userAgent);
  
  if (isAndroid) {
    // Intersection Observer APIを使用したより確実なフォールバック
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.target.style.opacity === '0') {
          gsap.to(entry.target, {
            y: 0,
            autoAlpha: 1,
            duration: 1.2,
            ease: "power2.out"
          });
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -10% 0px'
    });

    // ScrollTriggerが動作しない場合のタイムアウト処理
    setTimeout(() => {
      const fadeInTargets = document.querySelectorAll('.js-fadeInUp');
      fadeInTargets.forEach((target) => {
        if (target.style.opacity === '0') {
          observer.observe(target);
        }
      });
    }, 1500);

    // 画面向き変更時の処理
    let orientationTimeout;
    window.addEventListener('orientationchange', () => {
      clearTimeout(orientationTimeout);
      orientationTimeout = setTimeout(() => {
        // ScrollTriggerを再計算
        ScrollTrigger.refresh();
        
        // 表示されていない要素を強制表示
        const fadeInTargets = document.querySelectorAll('.js-fadeInUp');
        fadeInTargets.forEach((target) => {
          const rect = target.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
          
          if (isVisible && target.style.opacity === '0') {
            gsap.to(target, {
              y: 0,
              autoAlpha: 1,
              duration: 0.8,
              ease: "power2.out"
            });
          }
        });
      }, 500);
    });
  }
};

// FVセクションの強制表示（ハッシュリンク遷移時など）
const forceShowFV = () => {
  const fvWrap = document.querySelector('.fv .js-fadeInUp');
  if (fvWrap) {
    const rect = fvWrap.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    // 画面内にある場合は強制的に表示
    if (isVisible && (fvWrap.style.opacity === '0' || fvWrap.style.opacity === '')) {
      gsap.to(fvWrap, {
        y: 0,
        autoAlpha: 1,
        duration: 0.8,
        ease: "power2.out"
      });
    }
  }
  
  // FV背景の表示を確実にする
  const fvBg = document.querySelector('.fv__bg');
  if (fvBg) {
    // 背景画像が読み込まれているか確認
    const bgImage = window.getComputedStyle(fvBg).backgroundImage;
    if (bgImage && bgImage !== 'none') {
      // 背景が表示されるように強制
      fvBg.style.display = 'block';
      fvBg.style.visibility = 'visible';
      fvBg.style.opacity = '1';
    }
  }
  
  // Rellaxを再初期化
  if (typeof Rellax !== 'undefined') {
    const rellaxElements = document.querySelectorAll('.js-rellax');
    if (rellaxElements.length > 0) {
      // 既存のRellaxインスタンスを破棄
      const existingRellax = window.rellaxInstance;
      if (existingRellax) {
        existingRellax.destroy();
      }
      // 新しいRellaxインスタンスを作成
      window.rellaxInstance = new Rellax('.js-rellax', {
        speed: -7,
        center: false,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      });
    }
  }
};

// 実行 **********************************************************************
document.addEventListener("DOMContentLoaded", function () {
  debugAnimation(); // デバッグ機能を実行
  iPhoneOptimization(); // iPhone最適化を実行
  
  // Android専用の初期化遅延処理
  const isAndroid = /Android/i.test(navigator.userAgent);
  const initDelay = isAndroid ? 300 : 0;
  
  setTimeout(() => {
    const mm = gsap.matchMedia();
    // SPの時
    mm.add(`screen and (max-width: ${breakpoint - 1}px)`, () => {
      fadeInUp();
      fadeIn();
      androidFallback();
      // ハッシュリンクで遷移した場合はScrollTriggerをリフレッシュのみ
      if (location.hash) {
        setTimeout(() => {
          ScrollTrigger.refresh();
        }, 300);
      }
    });
    // PCの時
    mm.add(`screen and (min-width: ${breakpoint}px)`, () => {
      fadeInUp();
      fadeIn();
      androidFallback();
      // ハッシュリンクで遷移した場合はScrollTriggerをリフレッシュのみ
      if (location.hash) {
        setTimeout(() => {
          ScrollTrigger.refresh();
        }, 300);
      }
    });

    // Rellax
    if (typeof Rellax !== 'undefined') {
      window.rellaxInstance = new Rellax('.js-rellax', {
        speed: -7,
        center: false,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      });
    }
  }, initDelay);
});
